import { render, staticRenderFns } from "./TicketAddress.vue?vue&type=template&id=10d13b88&scoped=true"
import script from "./TicketAddress.vue?vue&type=script&lang=js"
export * from "./TicketAddress.vue?vue&type=script&lang=js"
import style0 from "./TicketAddress.vue?vue&type=style&index=0&id=10d13b88&prod&scoped=true&lang=less"
import style1 from "./TicketAddress.vue?vue&type=style&index=1&id=10d13b88&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d13b88",
  null
  
)

export default component.exports